import { IChallengeItem } from './fetch-service';

export const checkIfPlaidTemplate = (template: IChallengeItem[] | undefined): boolean | undefined => {
  if (!template) return false;

  let temp = false;
  template.forEach(el => {
    if (el.children) {
      const item = checkIfPlaidTemplate(el.children);
      if (item) {
        temp = true;
      }
    }
    if (el.inputType === 'OpenBanking_Plaid') {
      temp = true;
    }
  });

  return temp;
};

// FIXME: fix return type
export const checkIfSpreedly_3DS = (template: IChallengeItem[] | undefined): any => {
  if (!template) return false;

  let temp: any = {};
  template.forEach(el => {
    if (el.children) {
      const item = checkIfSpreedly_3DS(el.children);
      if (item && Object.keys(item).length) {
        temp = { ...item };
      }
    }
    if (el.inputType === 'Spreedly_3DS') {
      temp = { ...el };
    }
  });

  return temp;
};

export const checkIfTokenex_3DS = (template: IChallengeItem[] | undefined): any => {
  if (!template) return false;

  let temp: any = {};
  template.forEach(el => {
    if (el.children) {
      const item = checkIfTokenex_3DS(el.children);
      if (item && Object.keys(item).length) {
        temp = { ...item };
      }
    }
    if (el.inputType === 'Tokenex_3DS') {
      temp = { ...el };
    }
  });

  return temp;
};
